module.exports = __webpack_public_path__ + "static/img/6.559a73fd.png";